import React, { Component } from 'react';
import { Button, FormCheck, Modal } from 'react-bootstrap';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import ReactTable from 'react-table';

interface IProps {
  apply: Function;
  container: Object;
  hide: Function;
  partNum: string;
  qtyRequired: number;
  serialsAvailable: string[];
  serialsPreviouslySelected?: string[];
  show: boolean;
}

// We want case insensitive and searching within strings
const filterOverride = ({ id, value }: { id: string; value: string }, row: string[]) => {
  return row[id] ? row[id].toLowerCase().includes(value.toLowerCase()) : false;
};

@observer
class SerialNumbersSelectionModal extends Component<IProps, {}> {
  @observable serialNumbersChecked = new Set<string>();

  constructor(props: IProps) {
    super(props);

    const { serialsPreviouslySelected } = props;
    if (serialsPreviouslySelected) {
      serialsPreviouslySelected.forEach(serial => this.serialNumbersChecked.add(serial));
    }
  }

  render() {
    const { apply, container, hide, partNum, qtyRequired, serialsAvailable, show } = this.props;

    /* This ostensibly no-op line triggers mobx to re-render on serialNumbersChecked set changes.
       
       The only read of the set is deep within a react-table cell render function that MobX
       can't detect.  We require react-controlled checkbox inputs for react-table filters
       to work correctly, and are using MobX to manage that state with an obsevable set.
       This line tells MobX to observe serialNumbersChecked and re-render on changes.
    */
    this.serialNumbersChecked.has('mobx-trigger');

    return (
      <Modal backdrop="static" size="lg" container={container as any} onHide={hide as any} show={show}>
        <Modal.Header>
          <Modal.Title>{`${partNum} - ${qtyRequired} Required`}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ReactTable
            className="-striped"
            data={serialsAvailable.map(o => ({ x: o }))}
            defaultFilterMethod={filterOverride}
            defaultPageSize={serialsAvailable.length}
            showPagination={false}
            sortable={false}
            style={{
              maxHeight: '450px',
            }}
            columns={[
              {
                Cell: ({ value }) => {
                  return (
                    <FormCheck inline={true}>
                      <FormCheck.Input
                        type="checkbox"
                        className="sk-useMaterialInput"
                        onChange={(evt: any) => {
                          if (evt.target.checked) {
                            this.serialNumbersChecked.add(value);
                          } else {
                            this.serialNumbersChecked.delete(value);
                          }
                        }}
                        checked={this.serialNumbersChecked.has(value)}
                      />
                      <FormCheck.Label title={value}>&nbsp; &nbsp;{value}</FormCheck.Label>
                    </FormCheck>
                  );
                },
                Header: 'Serial Number Search & Selection',
                filterable: true,
                accessor: 'x',
              },
            ]}
          />
        </Modal.Body>
        <Modal.Footer>
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <div>
              {this.serialNumbersChecked.size} of {qtyRequired} Selected
            </div>
            <div>
              <Button onClick={() => hide()} variant="secondary">
                Close
              </Button>
              <Button
                onClick={() => apply([...this.serialNumbersChecked])}
                variant="success"
                disabled={this.serialNumbersChecked.size !== qtyRequired}
              >
                Apply
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default SerialNumbersSelectionModal;
